var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question
    ? _c(
        "div",
        {
          key: _vm.reRender,
          staticClass: "question-screen",
          attrs: { "justify-content-center": "", wrap: "" },
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "div",
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _c(
                      "v-card",
                      { staticClass: "question-card" },
                      [
                        _c(
                          "v-card-title",
                          { attrs: { "primary-title": "" } },
                          [
                            _vm.question.isDescriptionQuestion
                              ? _c("p", { staticClass: "title m-0" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("question.description", {
                                          format: _vm.LETTER_FORMAT.UPTITLECASE,
                                        })
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _c("p", { staticClass: "title m-0" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("question.problem", {
                                          format: _vm.LETTER_FORMAT.UPTITLECASE,
                                        }) +
                                          " " +
                                          (_vm.groupNumber + 1)
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _vm.isAnswered
                              ? _c("p", { staticClass: "score" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        Math.round(
                                          (_vm.score * 100) / _vm.totalScore
                                        )
                                      ) +
                                      "% "
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      "（ " +
                                        _vm._s(_vm.score) +
                                        "/" +
                                        _vm._s(_vm.totalScore) +
                                        "点 ）"
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c("ProgressRotate", {
                              attrs: {
                                score: 40,
                                value: (_vm.time * 100) / 60,
                                color: "#2699fb",
                                width: 15,
                                size: 30,
                                rotate: -90,
                                showLable: false,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider", { attrs: { light: "" } }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.groupQuestions,
                          function (currentQuestion, index) {
                            return _c("QuestionBodyComponent", {
                              key: currentQuestion.id,
                              attrs: {
                                question: currentQuestion,
                                questionNumber: index + 1,
                                totalQuestionNumber: _vm.totalQuestionNumber,
                                isAnswered: _vm.isAnswered,
                                totalQuestion: _vm.groupQuestions.length,
                              },
                              on: { onAnswer: _vm.onAnswerQuestion },
                            })
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          { staticClass: "answer-footer" },
                          [
                            _c("ChartProgress", {
                              key: _vm.questionNumber / _vm.totalQuestionNumber,
                              attrs: {
                                size: 160,
                                series: [
                                  (_vm.questionNumber * 100) /
                                    _vm.totalQuestionNumber,
                                ],
                                labelColor: "#2699fb",
                                label:
                                  _vm.questionNumber +
                                  "/" +
                                  _vm.totalQuestionNumber,
                                subLabel: _vm.$t("question.question", {
                                  format: _vm.LETTER_FORMAT.UPTITLECASE,
                                }),
                                chartColor: "#2699fb",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider", { attrs: { light: "" } }),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          { staticClass: "footer-card-question p-3" },
                          [
                            _c(
                              "div",
                              { attrs: { "justify-content-center": "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      text: "",
                                      icon: "",
                                      disabled: _vm.questionNumber <= 1,
                                    },
                                    on: { click: _vm.first },
                                  },
                                  [
                                    _vm._v(
                                      "\n                最初\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      text: "",
                                      icon: "",
                                      disabled: _vm.questionNumber <= 1,
                                    },
                                    on: { click: _vm.previous },
                                  },
                                  [
                                    _vm._v(
                                      "\n                前へ\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.question.isDescriptionQuestion
                                  ? _c("v-btn", {
                                      staticClass: "m-1 green-color",
                                      attrs: {
                                        rounded: "",
                                        color: "white",
                                        light: "",
                                        disabled: "",
                                      },
                                    })
                                  : [
                                      !_vm.isAnswered
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "m-1 green-color",
                                              attrs: {
                                                rounded: "",
                                                color: "white",
                                                light: "",
                                              },
                                              on: { click: _vm.onAnswer },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("common.answer", {
                                                      format:
                                                        _vm.LETTER_FORMAT
                                                          .UPTITLECASE,
                                                    })
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              staticClass: "m-1 green-color",
                                              attrs: {
                                                round: "",
                                                color: "white",
                                                light: "",
                                              },
                                              on: { click: _vm.onUnAnswer },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("common.un_answer", {
                                                      format:
                                                        _vm.LETTER_FORMAT
                                                          .UPTITLECASE,
                                                    })
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      text: "",
                                      icon: "",
                                      disabled:
                                        _vm.questionNumber >=
                                        _vm.totalQuestionNumber,
                                    },
                                    on: { click: _vm.next },
                                  },
                                  [
                                    _vm._v(
                                      "\n                次へ\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      text: "",
                                      icon: "",
                                      disabled:
                                        _vm.questionNumber >=
                                        _vm.totalQuestionNumber,
                                    },
                                    on: { click: _vm.last },
                                  },
                                  [
                                    _vm._v(
                                      "\n                最後\n              "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }